'use client';

import Script from 'next/script';
import { courseDetails } from '@/app/[locale]/(main)/payment/types';
import { AuthModal } from '@/components/auth-modal';
import { DMButton } from '@/components/button';
import { RainbowBg } from '@/components/Rainbow/Rainbow';
import { SkeletonLoader } from '@/components/skeleton-loader';
import { WordRotate } from '@/components/word-rotate';
import { usePayment } from '@/hooks/usePayment';
import { getOfferPercentage } from '@/lib/utils';
import { Loader } from 'lucide-react';
import PollingUi from './PollingUi';

declare global {
  interface Window {
    Razorpay: any;
  }
}

type EnrollButtonProps = {
  courseDetails: courseDetails;
};

export default function PaymentButton({ courseDetails }: EnrollButtonProps) {
  const { handlePayment, paymentId, loading } = usePayment();
  // const handlclik = () => {
  //   setPaymentId('pay_PJZHSqFoRqacp1');
  // };

  if (paymentId) {
    return <PollingUi />;
  }
  return (
    <>
      <Script src='https://checkout.razorpay.com/v1/checkout.js' strategy='lazyOnload' />
      <div className='md:my-8 md:mt-6 md:mb-2 max-sm:fixed max-sm:left-0 max-sm:right-0 max-sm:bottom-0 max-sm:flex max-sm:bg-brand-third max-sm:gap-4 max-sm:p-2'>
        <div className='flex gap-3 items-center my-4 mx-2'>
          {courseDetails?.price ? (
            <>
              <h2 className='font-bold'>₹{courseDetails.offerPrice || courseDetails?.price} </h2>
              <div className='max-sm:shrink-0 sm:flex sm:gap-2'>
                {!!courseDetails?.discountPercentage && (
                  <h4 className='text-sm line-through text-gray-400 max-sm:text-xs'>
                    ₹{courseDetails?.price}
                  </h4>
                )}
                {!!courseDetails?.discountPercentage && (
                  <p className='text-brand-primary max-sm:text-xs'>
                    {Math.ceil(courseDetails?.discountPercentage)}% off
                  </p>
                )}
              </div>
            </>
          ) : (
            <SkeletonLoader width={200} height={30} />
          )}
        </div>

        <RainbowBg className='mt-1'>
          <AuthModal>
            <DMButton
              className='flex items-center justify-center text-center w-full sm:my-6  font-semibold px-0 h-11'
              onClick={handlePayment}
              // variant='bgthird'
              loading={loading}
            >
              Enroll Now
            </DMButton>
          </AuthModal>
        </RainbowBg>
      </div>
    </>
  );
}
